<div class="gdp-feature-flags-table">
  <div class="vox-table">
    <table>
      <thead>
        <tr>
          <td scope="col" translate>internal-facilities.feature-flags.table.cells.name</td>
          <td scope="col" translate>internal-facilities.feature-flags.table.cells.description</td>
          <td scope="col" translate>internal-facilities.feature-flags.table.cells.lock</td>
          <td scope="col" translate>internal-facilities.feature-flags.table.cells.actions</td>
        </tr>
      </thead>
      <tbody *ngIf="!_loading">
        <ng-container *ngFor="let flag of flags; let i = index">
          <tr *ngIf="flag.loading">
            <td colspan="4">
              <ngx-skeleton-loader [theme]="{'margin-bottom': 0 }"></ngx-skeleton-loader>
            </td>
          </tr>
          <tr *ngIf="!flag.loading">
            <td>{{flag.key}}</td>
            <td>{{flag.description}}</td>
            <td>
              <gdp-status-icon [isEnabled]="flag.is_enabled"></gdp-status-icon>
            </td>
            <td class="dictionary-table__actions">
              <div class="dictionary-table__actions--wrapper">
                <button class="vox-btn btn btn-warning" (click)="updateFlag(flag)"
                [attr.aria-label]="'internal-facilities.feature-flags.table.actions.edit' | translate"
                [ngbTooltip]="'internal-facilities.feature-flags.table.actions.edit' | translate">
                  <i class="icon-small-edit"></i>
                </button>
                <button class="vox-btn btn btn-warning ml-1 mr-1" (click)="showFlagUsage(flag)"
                [attr.aria-label]="'internal-facilities.feature-flags.table.actions.usage' | translate"
                [ngbTooltip]="'internal-facilities.feature-flags.table.actions.usage' | translate">
                  <i class="icon-small-preferences"></i>
                </button>
                <button class="vox-btn btn btn-danger" (click)="deleteFlag(flag, flag.id)"
                [attr.aria-label]="'internal-facilities.feature-flags.table.actions.delete' | translate"
                [ngbTooltip]="'internal-facilities.feature-flags.table.actions.delete' | translate">
                  <i class="icon-small-delete"></i>
                </button>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tbody *ngIf="_loading">
        <tr *ngFor="let i of [1,2,3,4]">
          <td colspan="4">
            <ngx-skeleton-loader [theme]="{'margin-bottom': 0}"></ngx-skeleton-loader>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="!_loading && flags.length === 0">
        <tr>
          <td colspan="4" translate>internal-facilities.feature-flags.table.empty</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>